module.exports = __webpack_public_path__ + "img/ERP_swiperTab_bg4.d59c7a7e.png";